import { Fade } from "@mui/material";
import { useCanvasTilesStore } from "../store/canvas-tiles";
import { useProduct } from "../store/product";
import { StyledTile as CanvasTile, StyledTileLabel as TileLabel } from "./CanvasTiles.styles";
import { useCallback, useEffect, useLayoutEffect, useState } from "react";
import PassThroughDiv from "./PassThroughDiv";
import { useCropperStore } from "../store/cropper/cropper-store";
import { useCropperAction } from "../store/cropper/cropper-actions";

function CanvasTiles() {
  const { product } = useProduct();
  const { shown, tiles, containerStyles, setShown } = useCanvasTilesStore();
  const {action: currentCropperAction} = useCropperAction();
  const { preset, getCropper, isDark } = useCropperStore();
  const cropperJS = useCropperStore(s => s.getCropper());
  const [perimeter_, setPerimeter_] = useState({
    width: preset.width,
    height: preset.width,
  });

  const makeTile = (tileSize, count, color, cropperJS) => (_, index) => {
    const {width: cropBoxWidth} = cropperJS.cropBox.getBoundingClientRect();
    const pixelDelta = (cropBoxWidth / count) / cropBoxWidth;
    let sizePixel, sizeCM;
    if (cropperJS.preset.width % tileSize > 0 && /** is last tile? */(index === (Math.ceil(count) - 1))) {
      sizePixel = ((cropBoxWidth % (cropBoxWidth / count)) / cropBoxWidth) * 100;
      sizeCM    = cropperJS.preset.width % tileSize;
    } else {
      sizePixel = pixelDelta * 100;
      sizeCM    = tileSize;
    }
    const tileLeft  = (pixelDelta * 100) * index + "%";
    const tileWidth = sizePixel + "%";
    return {
      style: {
        left:  tileLeft,
        width: tileWidth,
        color,
      },
      label: `${sizeCM} cm`
    };
  };

  /**
   * la funzione make viene chiamata tramite il resize
   * oppure dentro a react-cropper.jsx quando termina il ciclo delle azioni dispatchate
   */
  const makeTiles = () => {
    if (getCropper()) {
      const tileSize = product.media.filter(({ sku }) => sku === preset.media)[0]?.panel_width;
      const count = perimeter_.width / tileSize;
      useCanvasTilesStore.setState({
        tiles: Array.from({ length: Math.ceil(count) }, 
          makeTile(tileSize, count, isDark ? "#fff" : "#000", cropperJS)
        ),
        containerStyles: cropperJS.cropBoxData,
      });
    }
  };

  useEffect(() =>{
    if (currentCropperAction) {
      const currentAction = Object.keys( currentCropperAction );
      switch( currentAction[0] ) {
        default: break;
        case 'perimeter':
          setPerimeter_({
            width: currentCropperAction.perimeter.width,
            height: currentCropperAction.perimeter.height,
          });
          break;
        case 'zeroAll':
          console.log('zeroAll');
          setShown(false);
          break;
      }
    }
  }, [currentCropperAction]);

  useLayoutEffect(() => {
    if ( currentCropperAction?.perimeter ) {
      makeTiles();
    }
  }, [perimeter_, currentCropperAction]);

  useEffect(() => {
    setPerimeter_({
      width: preset.width,
      height: preset.width,
    });
    if ( cropperJS ) {
      setTimeout(() => {
        useCanvasTilesStore.setState({
          containerStyles: cropperJS.cropBoxData 
        });
      });
    }
  }, [preset, cropperJS]);

  useLayoutEffect(() => {
      shown && makeTiles();
      const onResize = () => {
        if ( cropperJS && shown ) {
          useCanvasTilesStore.setState({
            containerStyles: cropperJS.cropBoxData 
          });
        }
      };
      /* -- on resize set container position -- */
      window.addEventListener('resize', onResize);
      return () => {
        window.removeEventListener('resize', onResize);
      }
  }, [shown, cropperJS]);

  return (
    <Fade in={shown}>
      <PassThroughDiv position="absolute" style={containerStyles}>
        {tiles.map((tile, i) => (
          <CanvasTile key={i} style={tile.style}>
            <TileLabel>{tile.label}</TileLabel>
          </CanvasTile>
        ))}
      </PassThroughDiv>
    </Fade>
  );
};

export default CanvasTiles;
